import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class coordinationActionsMenuCtrl implements IController {

  status: any;
  onDecline: Function;

  private disableConfig: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.disableConfig = {decline: false};
  };

  openActionsMenu($mdMenu, ev) {
    this.disableConfig = {decline: _.isEqual(this.status, 'Inactive')};
    $mdMenu.open(ev);
  }

}

angular
  .module('bringoz.admin.coordinations')
  .component('coordinationActionsMenu', {
    bindings: {
      status: '<',
      onDecline: '&'
    },
    template: require('./coordination-actions-menu.html').default,
    controller: coordinationActionsMenuCtrl
  });
